import { LoginForm } from "./components/login-form";

export const LoginPage = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="w-full max-w-sm px-4">
      <div className="flex flex-col items-center  mb-8 ">
        <img
          src="/greennode.svg"
          alt="Greennode"
          className="h-30 rounded-lg border"
        />
      </div>

      <LoginForm />
    </div>
  </div>
);
